import { render } from "./ChevronRightIcon.vue?vue&type=template&id=234a5fd8"
import script from "./ChevronRightIcon.vue?vue&type=script&lang=js"
export * from "./ChevronRightIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__